import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateCondition } from '../../../state';
import { useGetTicketFieldsQuery } from '../../../../../services/WorkflowService';
import { useWorkflowValidationContext, getConditionError } from '../../shared';

interface ConditionFieldInputProps {
  index: number;
}

export const ConditionFieldInput: React.FC<ConditionFieldInputProps> = ({ index }) => {
  const dispatch = useAppDispatch();
  const condition = useAppSelector((state) => state.workflow.currentWorkflow?.conditions[index]);
  const { data: ticketFields = [], isLoading: loadingFields } = useGetTicketFieldsQuery();
  const { errors, showErrors } = useWorkflowValidationContext();

  if (!condition) return null;

  const isValidField = ticketFields.some(field => field.value === condition.field);
  const selectValue = isValidField || loadingFields ? condition.field : '';
  const fieldErr = getConditionError(errors, showErrors, index, 'field');

  return (
    <FormControl size="small" sx={{ flex: 1, minWidth: 200 }} error={!!fieldErr}>
      <InputLabel>Field</InputLabel>
      <Select
        value={selectValue}
        label="Field"
        onChange={(e) => dispatch(updateCondition({ index, field: 'field', value: e.target.value }))}
        disabled={loadingFields}
      >
        {ticketFields.map((field) => (
          <MenuItem key={field.value} value={field.value} title={field.description}>
            {field.name}
          </MenuItem>
        ))}
      </Select>
      {fieldErr && <FormHelperText>{fieldErr}</FormHelperText>}
    </FormControl>
  );
};

export default ConditionFieldInput;
